import { RefObject } from 'react';

export type BasicDataType = string | number | boolean;

export type TranslateFunc = (key: string, vars?: Record<string, unknown>) => string;

export type FormValue = string | number | boolean | unknown;

export interface KitInputProps {
  className?: string;
  defaultValue?: FormValue;
  disabled?: boolean;
  error?: string | string[];
  focused?: boolean;
  id?: string;
  label?: string;
  name: string;
  onChange?: (e) => void;
  ref?: RefObject<HTMLInputElement>;
  required?: boolean;
  value?: FormValue;
}

export interface Option {
  label: string | null;
  value: number | null;
}

export interface Country {
  id: number;
  name: string;
  originalName: string;
  code: string;
  callingCode: string;
  phoneFormat: string;
  phoneVerificationSupported: boolean;
}

export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
}

export enum SortDir {
  DESC,
  ASC,
}

export enum PageWrapper {
  HEADER = 'header',
  MAIN = 'main',
  FOOTER = 'footer',
}

export type AriaSortDir = 'none' | 'ascending' | 'descending' | 'other';

export type PopOverPosition = 'bottom' | 'right' | 'left' | 'top';

export enum EventName {
  FOCUS = 'focus',
  KEYUP = 'keyup',
  RESIZE = 'resize',
  FOCUSOUT = 'focusout',
  FOCUSIN = 'focusin',
  MOUSEDOWN = 'mousedown',
}

export const EditMode = {
  EDIT: 'edit',
  READ_ONLY: 'read-only',
};

export enum KitToastTypeOptions {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  CUSTOM = 'custom',
}

/*
  Creates a type that requires exactly one of the given keys and disallows more. The remaining keys are kept as is.
  Usage:

  interface Foo {
     a: string;
     b: string;
     c: number;
  }

  const FooEnhanced:RequireExactlyOne<Foo, 'a' | 'b'> =

  @see https://github.com/sindresorhus/type-fest/blob/main/source/require-exactly-one.d.ts#L30
 */
export type RequireExactlyOne<ObjectType, KeysType extends keyof ObjectType = keyof ObjectType> = {
  [Key in KeysType]: Required<Pick<ObjectType, Key>> &
    Partial<Record<Exclude<KeysType, Key>, never>>;
}[KeysType] &
  Omit<ObjectType, KeysType>;
